import { useCallback } from "react";

import withDelayedHoverEvent from "app/pages/sales-intelligence/hoc/withDelayedHoverEvent";
import withMouseEventHandlers from "app/pages/sales-intelligence/hoc/withMouseEventHandlers";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import type { IntegrationAccount } from "app/pages/sales-intelligence/modules/company-analysis/types/crm-links";

import type { SingleAccountTagProps } from "./SingleAccountTag";
import SingleAccountTag from "./SingleAccountTag";

type SingleAccountTagTrackedProps = Pick<SingleAccountTagProps, "account">;

const AccountTagWithMouseEvents = withDelayedHoverEvent(withMouseEventHandlers(SingleAccountTag));

const SingleAccountTagTracked = ({ account }: SingleAccountTagTrackedProps) => {
    const handleAccountClick = useCallback((clickedAccount: IntegrationAccount) => {
        companyAnalysisTrackingService.overview.trackOpenCRMAccountFromSingle(clickedAccount.crmAccountId);
    }, []);

    const handleOnMouseEnter = (): void => {
        companyAnalysisTrackingService.overview.trackHoverCRMAccountFromSingle(account.crmAccountId);
    };

    return (
        <AccountTagWithMouseEvents
            account={account}
            onMouseEnter={handleOnMouseEnter}
            onAccountClick={handleAccountClick}
        />
    );
};

export default SingleAccountTagTracked;
